import React, { useEffect, useState } from "react";

import axios from "axios";
import { useLocation } from "react-router-dom";

const ContractPDF = ({ token }) => {
  const [loading, setLoading] = useState(false);
  const [contractData, setContractData] = useState(null);
  const PUBLIC_API_URL = process.env.REACT_APP_API_BASE_URL;
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const Verification_token = queryParams.get("token");

  useEffect(() => {
    let isMounted = true;

    if (!Verification_token) return;

    const fetchContractData = async () => {
      setLoading(true);
      try {
        const response = await axios.get(
          `${PUBLIC_API_URL}contract/?token=${Verification_token}`
        );

        if (isMounted) {
          setContractData(response.data.data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        if (isMounted) {
          setLoading(false);
        }
      }
      return () => {
        isMounted = false;
      };
    };

    fetchContractData();
  }, [Verification_token, PUBLIC_API_URL]);

  const handleDownloadPdf = async () => {
    if (!contractData?.contract_id) return;
    setLoading(true);
    try {
      const response = await axios.post(
        `${PUBLIC_API_URL}contract/generate-pdf`,
        { contract_id: contractData.contract_id },
        { responseType: "json" }
      );

      const { pdf, filename, contentType } = response.data.data;

      if (!pdf || !contentType) {
        throw new Error("PDF or contentType missing from response");
      }

      const dataUrl = `data:${contentType};base64,${pdf}`;
      const fetchResponse = await fetch(dataUrl);
      const blob = await fetchResponse.blob();

      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = filename || "contract.pdf";
      document.body.appendChild(link);
      link.click();

      window.URL.revokeObjectURL(url);
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error downloading PDF:", error);
    } finally {
      setLoading(false);
    }
  };
  if (!contractData || !contractData.guest || !contractData.host) {
    return <div>Loading contract details...</div>;
  }

  return (
    <div className="download_pdf_main">
      {/* pdf agreement content */}
      <div className="contract_agreement_wrapper">
        <div className="contract_agreement_content">
          <h2>1. Swap Agreement</h2>
          <button id="compatibility_score">
            Your compatibility score is : &ensp;{" "}
            {contractData?.match_score}%
          </button>
          <div className="contract_agreement_text">
            <p>
              This contract is made between {contractData?.host?.name} (referred
              to as the Host) and {contractData?.guest?.name} (referred to as
              the Guest ). The swap will take place from{" "}
              {contractData?.start_date} to {contractData?.end_date}
            </p>
            <p>
              The Host agrees to provide access to their home for the duration
              of this period. Any changes to the agreed dates must be
              communicated by the Host to the Guest in advance, so appropriate
              arrangements can be made. The Host confirms that the home is
              described as {contractData?.host?.cleanliness} upon arrival.
            </p>
            <p>
              The Guest is expected to maintain the cleanliness of the home and
              leave it in the same condition it was found. The Guest expects the
              flat to be {contractData?.guest?.cleanliness} upon arrival{" "}
              {contractData.expectations?.guest?.trash
                ? "take out the trash"
                : "no trash duties"}
              to take out the trash before departure. The Guest will{" "}
              {contractData.guest?.rules?.petsAllowed ? "" : "not"} bring any{" "}
              {contractData.guest?.rules?.petsAllowed
                ? "pets"
                : "not bring any pets"}{" "}
              and is considered a{" "}
              {contractData?.guest.rules?.smokingAllowed
                ? "smoker"
                : "smoker not allowed"}
              .
            </p>
            <p>Both parties agree to:</p>
            <ul className="parties_agrementList">
              <li>
                Share photos of their homes to show the current condition.
              </li>
              <li>
                Arrange a before the swap to ensure that expectations are
                aligned.
              </li>
            </ul>

            <p>
              Date of Agreement:{" "}
              {new Date(contractData?.host?.date_created).toLocaleDateString(
                "en-US",
                {
                  year: "numeric",
                  month: "long",
                  day: "numeric",
                }
              )}
            </p>
          </div>
        </div>

        <div className="contract_agreement_download_pdf_btn">
          <button
            className="download_pdf"
            onClick={handleDownloadPdf}
            disabled={!contractData?.contract_id}
          >
            {loading ? (
              <>
                Downloading.. &nbsp; <i className="fa fa-spinner fa-spin"></i>
              </>
            ) : (
              "Download PDF"
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ContractPDF;
